var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 44,
  viewBox: "0 0 64 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 62,
  height: 42,
  rx: 5,
  stroke: "currentColor",
  strokeWidth: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 26,
  width: 21.3165,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 32,
  width: 15.7674,
  height: 2,
  rx: 1,
  fill: "currentColor"
})));
export { SvgCard as ReactComponent };